import type { Maybe } from '../../../../types/maybe.types';

import type {
  UiAuthUser,
  UiUserAboutStep,
} from '../../../../schemas/users.schema';

// 7.3 — sex and age decide the fitness score rows (VO2max among them), so
// nothing is guessed for them: the account's own values, or empty — the step
// asks for both. Height and weight keep their 0 placeholder.
export const aboutStepDefaults = (user: Maybe<UiAuthUser>) =>
  ({
    dateOfBirth: user?.settings?.dateOfBirth ?? null,
    gender: user?.settings?.gender
      ? [{ label: '', value: user.settings.gender }]
      : [],
    height: user?.fitnessProfile?.height || 0,
    weight: user?.fitnessProfile?.weight || 0,
  }) as UiUserAboutStep;
